var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.258268 11.1784C0.152931 11.0729 0.0937634 10.93 0.0937634 10.7809C0.0937634 10.6318 0.152931 10.4889 0.258268 10.3834L4.54752 6.0934L0.258269 1.8034C0.206068 1.7512 0.164661 1.68923 0.13641 1.62103C0.10816 1.55282 0.0936184 1.47972 0.0936184 1.4059C0.0936184 1.33208 0.10816 1.25898 0.13641 1.19077C0.164661 1.12257 0.206069 1.0606 0.258269 1.0084C0.31047 0.956199 0.37244 0.914792 0.440643 0.886541C0.508847 0.85829 0.581946 0.84375 0.655769 0.84375C0.729591 0.84375 0.802691 0.85829 0.870894 0.886541C0.939097 0.914792 1.00107 0.956199 1.05327 1.0084L5.74077 5.6959C5.84611 5.80137 5.90527 5.94434 5.90527 6.0934C5.90527 6.24246 5.84611 6.38543 5.74077 6.4909L1.05327 11.1784C0.947799 11.2837 0.804832 11.3429 0.655768 11.3429C0.506705 11.3429 0.363738 11.2837 0.258268 11.1784Z",
    fill: "#A3A1B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.5ea8378d0668371d5fbf1a0f05cf1e34.svg";
export { ForwardRef as ReactComponent };